import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function loadAnalytics() {
  if (window._gaLoaded) return;
  window._gaLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-B7320XJS44';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', 'G-B7320XJS44');
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    } else if (consent === 'accepted') {
      loadAnalytics();
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
    loadAnalytics();
  };

  const reject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-primary text-warm-white px-4 py-4 md:py-5 shadow-2xl">
      <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
        <p className="text-sm leading-relaxed flex-1">
          Questo sito utilizza cookie tecnici necessari al funzionamento e, previo consenso, cookie analitici di Google Analytics per migliorare l'esperienza.{' '}
          <Link to="/cookie/" className="underline hover:text-accent transition-colors text-warm-white">
            Cookie Policy
          </Link>
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            type="button"
            onClick={reject}
            className="px-4 py-2 text-sm border border-warm-white/40 rounded hover:border-warm-white transition-colors"
          >
            Rifiuta
          </button>
          <button
            type="button"
            onClick={accept}
            className="px-4 py-2 text-sm bg-accent text-white rounded hover:bg-accent/90 transition-colors font-medium"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
